import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { observableToBeFn } from 'rxjs/internal/testing/TestScheduler';
interface NotificationType {
  ticketStatus: boolean;
  probability: boolean;
  userAdded: boolean;
  userEdited: boolean;
  userDeleted: boolean;
  zoneAdded: boolean;
  zoneEdited: boolean;
  zoneDeleted: boolean;
  operatorAdded: boolean;
  operatorEdited: boolean;
  operatorDeleted: boolean;
  deviceEdited: boolean;
  deviceDeleted: boolean;
  vehicleAdded: boolean;
  vehicleEdited: boolean;
  vehicleDeleted: boolean;
}
 
@Injectable({
  providedIn: 'root',
})
export class UtilsService {
  /**
   * Reset all BehaviorSubjects and clear all state. Call this on logout to prevent further emissions and API calls.
   */
  resetAll() {
    // Complete all subjects
    this.notificationSubject.complete();
    this.dateFilterSubject.complete();
    this.deviceFilterSubject.complete();
    this.EntityIdSubject.complete();
    this.vehiclesListSubject.complete();
    this.SelectedVehiclesSubject.complete();
    this.SelectedVehiclesSubject1.complete();
    this.selectedCategorySubject.complete();
    this.selectedGateCategorySubject.complete();
    this.selectedMheCategorySubject.complete();
    this.selectedPPECategorySubject.complete();
    this.statusFilterSubject.complete();
    this.cameraFilterSubject.complete();
    this.cameraGFilterSubject.complete();
    this.sidenavSubject.complete();
    this.detectionFilterSubject.complete();
    this.ppeGateFilterSubject.complete();
    this.trendSubject.complete();
    this.trendforkliftSubject.complete();
    this.areaGraphSubject.complete();
    this.forkliftGraphSubject.complete();
    this.ppeVehicleFilterSubject.complete();
    this.detectionPDNCFilterSubject.complete();
    this.paginationSubject.complete();
    this.deviceGateFilterSubject.complete();
    this.deviceVehFilterSubject.complete();
    this.GateAccessSubject.complete();
    this.GrantAccessSubject.complete();
    this.GateDetectionAccessSubject.complete();
    this.GatePPEDetectionAccessSubject.complete();
    this.GateFilterSubject.complete();
    this.ForkliftFilterSubject.complete();
    this.ForkliftAccessSubject.complete();
    this.tokenSubject.complete();
    this.monthFilterEnabledSubject.complete();
    this.WorksiteFilterSubject.complete();
    this.ZoneFilterSubject.complete();
    this.DirectionFilterSubject.complete();
    this.priorityFilterSubject.complete();
    this.falseReportFilterSubject.complete();
    this.VehicleFilterSubject.complete();
    this.vehicleCoordinatesSubject.complete();
    this.zoneGeofencesSubject.complete();
    this.zoneDataSubject.complete();
    this.incidentIdSearchValue.complete();
    this.filteredGeofencesSubject.complete();
    this.vehicleCoordinatesSource.complete();
    this.vehicleStatusLiveSubject.complete();
    this.totalCountSource.complete();
  // Clear all public data properties
  this.selectedDateFilter = null;
  this.selectedDeviceFilter = null;
  this.gateNames = [];
  this.vehicleNames = [];
  this.vehicleCoordinatesData = [];
  this.vehiclestatusData = [];
  this.gateDetectionFilter = {};
  this.areaGraph = null;
  this.forkliftGraph = null;
  this.ForkliftAccess = null;
  this.GateAccess = null;
  this.zoneGeofences = [];
  this.filteredGeofences = [];
  this.zoneData = [];
  this.selectedEntityId = null;
  // Optionally: clear any other custom state properties here
  // Re-initialize all subjects so app can be used after re-login without refresh
  this.reinitializeSubjects();

  this.departmentFilterSubject.next([]);
  this.subDepartmentFilterSubject.next([]);
  }

  /**
   * Re-initialize all BehaviorSubjects after reset, so app can be used after re-login without refresh.
   */
  private reinitializeSubjects() {
    this.notificationSubject = new BehaviorSubject<NotificationType>({
      userAdded: false,
      userEdited: false,
      userDeleted: false,
      zoneAdded: false,
      zoneEdited: false,
      zoneDeleted: false,
      operatorAdded: false,
      operatorEdited: false,
      operatorDeleted: false,
      deviceEdited: false,
      deviceDeleted: false,
      vehicleAdded: false,
      vehicleEdited: false,
      vehicleDeleted: false,
      ticketStatus: false,
      probability: false,
    });
    this.dateFilterSubject = new BehaviorSubject<any>(null);
    this.deviceFilterSubject = new BehaviorSubject<any>(null);
    this.EntityIdSubject = new BehaviorSubject<any>(null);
    this.vehiclesListSubject = new BehaviorSubject<any>(null);
    this.SelectedVehiclesSubject = new BehaviorSubject<any>(null);
    this.SelectedVehiclesSubject1 = new BehaviorSubject<any>(null);
    this.selectedCategorySubject = new BehaviorSubject<any>(null);
    this.selectedGateCategorySubject = new BehaviorSubject<any>(null);
    this.selectedMheCategorySubject = new BehaviorSubject<any>(null);
    this.selectedPPECategorySubject = new BehaviorSubject<any>(null);
    this.statusFilterSubject = new BehaviorSubject<any>(null);
    this.cameraFilterSubject = new BehaviorSubject<any>(null);
    this.cameraGFilterSubject = new BehaviorSubject<any>(null);
    this.sidenavSubject = new BehaviorSubject<any>(null);
    this.detectionFilterSubject = new BehaviorSubject<any>(null);
    this.ppeGateFilterSubject = new BehaviorSubject<any>(null);
    this.trendSubject = new BehaviorSubject<any>(null);
    this.trendforkliftSubject = new BehaviorSubject<any>(null);
    this.areaGraphSubject = new BehaviorSubject<any>(null);
    this.forkliftGraphSubject = new BehaviorSubject<any>(null);
    this.ppeVehicleFilterSubject = new BehaviorSubject<any>(null);
    this.detectionPDNCFilterSubject = new BehaviorSubject<any>(null);
    this.paginationSubject = new BehaviorSubject<any>(null);
    this.deviceGateFilterSubject = new BehaviorSubject<any>(null);
    this.deviceVehFilterSubject = new BehaviorSubject<any>(null);
    this.GateAccessSubject = new BehaviorSubject<any>(null);
    this.GrantAccessSubject = new BehaviorSubject<any>(null);
    this.GateDetectionAccessSubject = new BehaviorSubject<any>(null);
    this.GatePPEDetectionAccessSubject = new BehaviorSubject<any>(null);
    this.GateFilterSubject = new BehaviorSubject<any>(null);
    this.ForkliftFilterSubject = new BehaviorSubject<any>(null);
    this.ForkliftAccessSubject = new BehaviorSubject<any>(null);
    this.tokenSubject = new BehaviorSubject<string | null>(null);
    this.monthFilterEnabledSubject = new BehaviorSubject<boolean>(false);
    this.WorksiteFilterSubject = new BehaviorSubject<any>(null);
    this.ZoneFilterSubject = new BehaviorSubject<any>(null);
    this.DirectionFilterSubject = new BehaviorSubject<any>(null);
    this.priorityFilterSubject = new BehaviorSubject<any>(null);
    this.falseReportFilterSubject = new BehaviorSubject<any>(null);
    this.VehicleFilterSubject = new BehaviorSubject<any>(null);
    this.vehicleCoordinatesSubject = new BehaviorSubject<any>(null);
    this.zoneGeofencesSubject = new BehaviorSubject<any[]>([]);
    this.zoneDataSubject = new BehaviorSubject<any[]>([]);
    this.incidentIdSearchValue = new BehaviorSubject<string>('');
    this.filteredGeofencesSubject = new BehaviorSubject<any[]>([]);
    this.vehicleCoordinatesSource = new BehaviorSubject<any[]>([]);
    this.vehicleStatusLiveSubject = new BehaviorSubject<any>(null);
    this.totalCountSource = new BehaviorSubject<number>(0);
  }
  selectedDateFilter: any;
  selectedDeviceFilter: any;
  private notificationSubject = new BehaviorSubject<NotificationType>({
    userAdded: false,
    userEdited: false,
    userDeleted: false,
    zoneAdded: false,
    zoneEdited: false,
    zoneDeleted: false,
    operatorAdded: false,
    operatorEdited: false,
    operatorDeleted: false,
    deviceEdited: false,
    deviceDeleted: false,
    vehicleAdded: false,
    vehicleEdited: false,
    vehicleDeleted: false,
    ticketStatus: false,
    probability: false,
  });
  private dateFilterSubject = new BehaviorSubject<any>(null);
  private deviceFilterSubject = new BehaviorSubject<any>(null);
  private vehiclesListSubject = new BehaviorSubject<any>(null);
  private SelectedVehiclesSubject = new BehaviorSubject<any>(null);
  private SelectedVehiclesSubject1 = new BehaviorSubject<any>(null);
  private selectedCategorySubject = new BehaviorSubject<any>(null);
  private selectedGateCategorySubject = new BehaviorSubject<any>(null);
  private selectedMheCategorySubject = new BehaviorSubject<any>(null);
  private selectedPPECategorySubject = new BehaviorSubject<any>(null);
  private statusFilterSubject = new BehaviorSubject<any>(null);
  private cameraFilterSubject = new BehaviorSubject<any>(null);
  private cameraGFilterSubject = new BehaviorSubject<any>(null);
  private sidenavSubject = new BehaviorSubject<any>(null);
  private detectionFilterSubject = new BehaviorSubject<any>(null);
  private ppeGateFilterSubject = new BehaviorSubject<any>(null);
  private trendSubject = new BehaviorSubject<any>(null);
  private trendforkliftSubject = new BehaviorSubject<any>(null);
  private areaGraphSubject = new BehaviorSubject<any>(null);
  private forkliftGraphSubject = new BehaviorSubject<any>(null);
  private ppeVehicleFilterSubject = new BehaviorSubject<any>(null);
  private detectionPDNCFilterSubject = new BehaviorSubject<any>(null);
  private paginationSubject = new BehaviorSubject<any>(null);
  private deviceGateFilterSubject = new BehaviorSubject<any>(null);
  private deviceVehFilterSubject = new BehaviorSubject<any>(null);
  private GateAccessSubject = new BehaviorSubject<any>(null);
  private GrantAccessSubject = new BehaviorSubject<any>(null);
  private GateDetectionAccessSubject = new BehaviorSubject<any>(null);
  private GatePPEDetectionAccessSubject = new BehaviorSubject<any>(null);
  private GateFilterSubject = new BehaviorSubject<any>(null);
  private ForkliftFilterSubject = new BehaviorSubject<any>(null);
  private ForkliftAccessSubject = new BehaviorSubject<any>(null);
  private tokenSubject = new BehaviorSubject<string | null>(null);
  private monthFilterEnabledSubject = new BehaviorSubject<boolean>(false);
  private hourFilterEnabledSubject = new BehaviorSubject<boolean>(false);
  private WorksiteFilterSubject = new BehaviorSubject<any>(null);
  private ZoneFilterSubject = new BehaviorSubject<any>(null);
  private DirectionFilterSubject = new BehaviorSubject<any>(null);
  private EntityIdSubject = new BehaviorSubject<any>(null);
  private CitySubject = new BehaviorSubject<string | null>(null);
  private priorityFilterSubject = new BehaviorSubject<any>(null);
  private falseReportFilterSubject = new BehaviorSubject<any>(null);
  private VehicleFilterSubject = new BehaviorSubject<any>(null);
  private vehicleCoordinatesSubject = new BehaviorSubject<any>(null);
  private zoneGeofencesSubject = new BehaviorSubject<any[]>([]);
  private zoneDataSubject = new BehaviorSubject<any[]>([]);
  public incidentIdSearchValue = new BehaviorSubject<string>('');
  private filteredGeofencesSubject = new BehaviorSubject<any[]>([]);
  // Expose a separate subject for geofence IDs (numbers) so APIs can consume ids directly
  // Initialize to empty array to make empty-state emissions consistent across subscribers.
  private filteredGeofenceIdsSubject = new BehaviorSubject<number[] | null>([]);
  private gateNames: string[] = [];
  private vehicleNames: string[] = [];
  private vehicleCoordinatesSource = new BehaviorSubject<any[]>([]);
  private vehicleStatusLiveSubject = new BehaviorSubject<any>(null);
  private totalCountSource = new BehaviorSubject<number>(0);
  private locationFilterSubject = new BehaviorSubject<string[]>([]);
  private locationCoordinatesSubject = new BehaviorSubject<any>(null);
  private departmentFilterSubject = new BehaviorSubject<string[]>([]);
  public departmentFilter$ = this.departmentFilterSubject.asObservable();
  
  private subDepartmentFilterSubject = new BehaviorSubject<string[]>([]);
  public subDepartmentFilter$ = this.subDepartmentFilterSubject.asObservable();
  private _selectedDefaultDate = new BehaviorSubject<string>('');
  selectedDefaultDate$ = this._selectedDefaultDate.asObservable();

  vehicleCoordinatesData: any[] = [];
  vehiclestatusData: any[] = [];
  gateDetectionFilter: { [gateId: string]: string[] } = {};
  constructor(readonly http: HttpClient) {}
  /* Getter for date filter in reports */
  totalCount$ = this.totalCountSource.asObservable();
  get dateFilter(): any {
    return this.selectedDateFilter;
  }

  setGateNames(names: string[]): void {
    this.gateNames = names;
  }
  getGateNames(): string[] {
    return this.gateNames;
  }
  setVehicleNames(names: string[]): void {
    this.vehicleNames = names;
  }
  getVehicleNames(): string[] {
    return this.vehicleNames;
  }
  setTotalCount(count: number) {
    this.totalCountSource.next(count);
  }
  /* Setter for date filter */
  set dateFilter(filter: any) {
    this.selectedDateFilter = filter;
    this.dateFilterSubject.next(filter);
  }
  /* Observable to track date filter changes */
  get dateFilter$(): Observable<any> {
    return this.dateFilterSubject.asObservable();
  }
 
  get deviceGateFilter(): any {
    return this.deviceGateFilterSubject.getValue();
  }
  set deviceGateFilter(filter: any) {
    this.deviceGateFilterSubject.next(filter);
  }
  get selectedDefaultDate(): string { return this._selectedDefaultDate.getValue(); }
  set selectedDefaultDate(val: string) { this._selectedDefaultDate.next(val); }
      /* Observable to track device filter changes */
      get GateFilter$(): Observable<any> {
        return this.GateFilterSubject.asObservable();
      }
      get GateFilter(): any {
        return this.GateFilterSubject.getValue();
      }
      set GateFilter(filter: any) {
        this.GateFilterSubject.next(filter);
      }
       /* Observable to track device filter changes */
       get ForkliftFilter$(): Observable<any> {
        return this.ForkliftFilterSubject.asObservable();
      }
      get ForkliftFilter(): any {
        return this.ForkliftFilterSubject.getValue();
      }
      set ForkliftFilter(filter: any) {
        this.ForkliftFilterSubject.next(filter);
      }

       get WorksiteFilter$(): Observable<any> {
        return this.WorksiteFilterSubject.asObservable();
      }
      get WorksiteFilter(): any {
        return this.WorksiteFilterSubject.getValue();
      }
      set WorksiteFilter(filter: any) {
        this.WorksiteFilterSubject.next(filter);
      }

      get vehiclestatus$(): Observable<any> {
        return this.vehicleCoordinatesSource.asObservable();
      }
      get vehiclestatus(): any[] {
        return this.vehicleCoordinatesSource.getValue();
      }
      set vehiclestatus(vehicles: any[]) {
        this.vehicleCoordinatesSource.next(vehicles);
      }

      updateVehicleCoordinates(coords: any[]) {
      this.vehicleCoordinatesData = coords;
      this.vehicleCoordinatesSource.next(coords);
    }

       get vehicleCoordinates$(): Observable<any> {
        return this.vehicleCoordinatesSubject.asObservable();
      }
      get vehicleCoordinates(): any {
        return this.vehicleCoordinatesSubject.getValue();
      }
      set vehicleCoordinates(filter: any) {
        this.vehicleCoordinatesSubject.next(filter);
      }

       get vehicleStatusLive$(): Observable<any> {
        return this.vehicleStatusLiveSubject.asObservable();
      }
      get vehicleStatusLive(): any {
        return this.vehicleStatusLiveSubject.getValue();
      }
      set vehicleStatusLive(filter: any) {
        this.vehicleStatusLiveSubject.next(filter);
      }
      get zoneGeofences$(): Observable<any[]> {
        return this.zoneGeofencesSubject.asObservable();
      }
      get zoneGeofences(): any[] {
        return this.zoneGeofencesSubject.getValue();
      }
      set zoneGeofences(value: any[]) {
        this.zoneGeofencesSubject.next(value);
      }
       get zoneData$(): Observable<any[]> {
        return this.zoneDataSubject.asObservable();
      }
      get zoneData(): any[] {
        return this.zoneDataSubject.getValue();
      }
      set zoneData(value: any[]) {
        this.zoneDataSubject.next(value);
      }

      get filteredGeofences$(): Observable<any[]> {
        return this.filteredGeofencesSubject.asObservable();
      }
      
      get filteredGeofences(): any[] {
        return this.filteredGeofencesSubject.getValue();
      }
      
      set filteredGeofences(value: any[]) {
        this.filteredGeofencesSubject.next(value);
      }
      // Expose ids-only observable for API calls
      get filteredGeofenceIds$(): Observable<number[] | null> {
        return this.filteredGeofenceIdsSubject.asObservable();
      }

      get filteredGeofenceIds(): number[] | null {
        return this.filteredGeofenceIdsSubject.getValue();
      }

      set filteredGeofenceIds(value: number[] | null) {
        this.filteredGeofenceIdsSubject.next(value);
      }


      get ZoneFilter$(): Observable<any> {
        return this.ZoneFilterSubject.asObservable();
      }
      get ZoneFilter(): any {
        return this.ZoneFilterSubject.getValue();
      }
      set ZoneFilter(filter: any) {
        this.ZoneFilterSubject.next(filter);
      }
      
      get locationCoordinates$(): Observable<any> {
        return this.locationCoordinatesSubject.asObservable();
      }
      get locationCoordinates(): any {
        return this.locationCoordinatesSubject.getValue();
      }
      set locationCoordinates(coords: any) {
        this.locationCoordinatesSubject.next(coords);
      }

      get LocationFilter$(): Observable<string[]> {
        return this.locationFilterSubject.asObservable();
      }
      get LocationFilter(): string[] {
        return this.locationFilterSubject.getValue();
      }
      set LocationFilter(filter: string[]) {
        this.locationFilterSubject.next(filter);
      }

      get DepartmentFilter$(): Observable<string[]> {
        return this.departmentFilterSubject.asObservable();
      }
      get DepartmentFilter(): string[] {
        return this.departmentFilterSubject.value;
      }
      set DepartmentFilter(value: string[]) {
        this.departmentFilterSubject.next(value);
      }
      
      get SubDepartmentFilter$(): Observable<string[]> {
        return this.subDepartmentFilterSubject.asObservable();
      }
      get SubDepartmentFilter(): string[] {
        return this.subDepartmentFilterSubject.value;
      }
      
      set SubDepartmentFilter(value: string[]) {
        this.subDepartmentFilterSubject.next(value);
      }

      get DirectionFilter$(): Observable<any> {
        return this.DirectionFilterSubject.asObservable();
      }
      get DirectionFilter(): any {
        return this.DirectionFilterSubject.getValue();
      }
      set DirectionFilter(filter: any) {
        this.DirectionFilterSubject.next(filter);
      }

    /** Observable */
get selectedCity$(): Observable<string | null> {
  return this.CitySubject.asObservable();
}

/** Getter */
get selectedCity(): string | null {
  return (
    this.CitySubject.getValue() ??
    localStorage.getItem('selected_city')
  );
}

/** Setter */
set selectedCity(city: string | null) {
  this.CitySubject.next(city);

  if (city) {
    localStorage.setItem('selected_city', city);
  } else {
    localStorage.removeItem('selected_city');
  }
}

  get selectedEntityId$(): Observable<number | null> {
    return this.EntityIdSubject.asObservable();
  }
  /* ---------- GET ---------- */
  get selectedEntityId(): number | null {
    return (
      this.EntityIdSubject.getValue() ??
      Number(localStorage.getItem('entity_id'))
    );
  }
  /* ---------- SET (IMPORTANT) ---------- */
  set selectedEntityId(entityId: number | null) {
    this.EntityIdSubject.next(entityId);
    if (entityId !== null && entityId !== undefined) {
      localStorage.setItem('entity_id', entityId.toString());
    } else {
      localStorage.removeItem('entity_id');
    }
  }
        get priorityFilter$(): Observable<any> {
        return this.priorityFilterSubject.asObservable();
      }
      get priorityFilter(): any {
        return this.priorityFilterSubject.getValue();
      }
      set priorityFilter(filter: any) {
        this.priorityFilterSubject.next(filter);
      }

      get falseReportFilter$(): Observable<any> {
        return this.falseReportFilterSubject.asObservable();
      }
      get falseReportFilter(): any {
        return this.falseReportFilterSubject.getValue();
      }
      set falseReportFilter(filter: any) {
        this.falseReportFilterSubject.next(filter);
      }

      get VehicleFilter$(): Observable<any> {
        return this.VehicleFilterSubject.asObservable();
      }
      get VehicleFilter(): any {
        return this.VehicleFilterSubject.getValue();
      }
      set VehicleFilter(filter: any) {
        this.VehicleFilterSubject.next(filter);
      }

      get incidentIdSearchValueFilter$(): Observable<any> {
        return this.incidentIdSearchValue.asObservable();
      }
      get incidentIdSearchValueFilter(): any {
        return this.incidentIdSearchValue.getValue();
      }
      set incidentIdSearchValueFilter(filter: any) {
        this.incidentIdSearchValue.next(filter);
      }

    /* Observable to track device filter changes */
    get GateAccess$(): Observable<any> {
      return this.GateAccessSubject.asObservable();
    }
    get GateAccess(): any {
      return this.GateAccessSubject.getValue();
    }
    set GateAccess(filter: any) {
      this.GateAccessSubject.next(filter);
    }
     /* Observable to track device filter changes */
     get GrantAccess$(): Observable<any> {
      return this.GrantAccessSubject.asObservable();
    }
    get GrantAccess(): any {
      return this.GrantAccessSubject.getValue();
    }
    set GrantAccess(filter: any) {
      this.GrantAccessSubject.next(filter);
    }
        /* Observable to track device filter changes */
        get GateDetectionAccess$(): Observable<any> {
          return this.GateDetectionAccessSubject.asObservable();
        }
        get GateDetectionAccess(): any {
          return this.GateDetectionAccessSubject.getValue();
        }
        set GateDetectionAccess(filter: any) {
          this.GateDetectionAccessSubject.next(filter);
        }
        /* Observable to track device filter changes */
        get GatePPEDetectionAccess$(): Observable<any> {
          return this.GatePPEDetectionAccessSubject.asObservable();
        }
        get GatePPEDetectionAccess(): any {
          return this.GatePPEDetectionAccessSubject.getValue();
        }
        set GatePPEDetectionAccess(filter: any) {
          this.GatePPEDetectionAccessSubject.next(filter);
        }
      /* Observable to track device filter changes */
      get ForkliftAccess$(): Observable<any> {
        return this.ForkliftAccessSubject.asObservable();
      }
      get ForkliftAccess(): any {
        return this.ForkliftAccessSubject.getValue();
      }
      set ForkliftAccess(filter: any) {
        this.ForkliftAccessSubject.next(filter);
      }  
  /* Observable to track device filter changes */
  get deviceGateFilter$(): Observable<any> {
    return this.deviceGateFilterSubject.asObservable();
  }
  get deviceVehFilter(): any {
    return this.deviceVehFilterSubject.getValue();
  }
  set deviceVehFilter(filter: any) {
    this.deviceVehFilterSubject.next(filter);
  }
  /* Observable to track device filter changes */
  get deviceVehFilter$(): Observable<any> {
    return this.deviceVehFilterSubject.asObservable();
  }
  /* Getter and Setter for device filter */
  get deviceFilter(): any {
    return this.deviceFilterSubject.getValue();
  }
  set deviceFilter(filter: any) {
    this.deviceFilterSubject.next(filter);
  }
  /* Observable to track device filter changes */
  get deviceFilter$(): Observable<any> {
    return this.deviceFilterSubject.asObservable();
  }
  get vehiclesList(): any {
    return this.vehiclesListSubject.getValue();
  }
  set vehiclesList(filter: any) {
    this.vehiclesListSubject.next(filter);
  }
  /* Observable to track device filter changes */
  get vehiclesList$(): Observable<any> {
    return this.vehiclesListSubject.asObservable();
  }
  get selectedvehicles(): any {
    return this.SelectedVehiclesSubject.getValue();
  }
  set selectedvehicles(filter: any) {
    this.SelectedVehiclesSubject.next(filter);
  }
  /* Observable to track device filter changes */
  get selectedvehicles$(): Observable<any> {
    return this.SelectedVehiclesSubject.asObservable();
  }
  get selectedvehicles1(): any {
    return this.SelectedVehiclesSubject1.getValue();
  }
  set selectedvehicles1(filter: any) {
    this.SelectedVehiclesSubject1.next(filter);
  }
  /* Observable to track device filter changes */
  get selectedvehicles1$(): Observable<any> {
    return this.SelectedVehiclesSubject1.asObservable();
  }
  get selectedCategory(): any {
    return this.selectedCategorySubject.getValue();
  }
  set selectedCategory(filter: any) {
    this.selectedCategorySubject.next(filter);
  }
  /* Observable to track device filter changes */
  get selectedCategory$(): Observable<any> {
    return this.selectedCategorySubject.asObservable();
  }
  get selectedGateCategory(): any {
    return this.selectedGateCategorySubject.getValue();
  }
  set selectedGateCategory(filter: any) {
    this.selectedGateCategorySubject.next(filter);
  }
  /* Observable to track device filter changes */
  get selectedGateCategory$(): Observable<any> {
    return this.selectedGateCategorySubject.asObservable();
  }
  get selectedMheCategory(): any {
    return this.selectedMheCategorySubject.getValue();
  }
  set selectedMheCategory(filter: any) {
    this.selectedMheCategorySubject.next(filter);
  }
  /* Observable to track device filter changes */
  get selectedMheCategory$(): Observable<any> {
    return this.selectedMheCategorySubject.asObservable();
  }
  get selectedPPECategory(): any {
    return this.selectedPPECategorySubject.getValue();
  }
  set selectedPPECategory(filter: any) {
    this.selectedPPECategorySubject.next(filter);
  }
  /* Observable to track device filter changes */
  get selectedPPECategory$(): Observable<any> {
    return this.selectedPPECategorySubject.asObservable();
  }
  /* Getter and Setter for device filter */
  get statusFilter(): any {
    return this.statusFilterSubject.getValue();
  }
  set statusFilter(filter: any) {
    this.statusFilterSubject.next(filter);
  }
  /* Observable to track device filter changes */
  get statusFilter$(): Observable<any> {
    return this.statusFilterSubject.asObservable();
  }
  get detectionFilter(): any {
    return this.detectionFilterSubject.getValue();
  }
  set detectionFilter(filter: any) {
    this.detectionFilterSubject.next(filter);
  }
  /* Observable to track device filter changes */
  get detectionFilter$(): Observable<any> {
    return this.detectionFilterSubject.asObservable();
  }
  get detectionPDNCFilter(): any {
    return this.detectionPDNCFilterSubject.getValue();
  }
  set detectionPDNCFilter(filter: any) {
    this.detectionPDNCFilterSubject.next(filter);
  }
  /* Observable to track device filter changes */
  get detectionPDNCFilter$(): Observable<any> {
    return this.detectionPDNCFilterSubject.asObservable();
  }
  get pagination(): any {
    return this.paginationSubject.getValue();
  }
  set pagination(filter: any) {
    this.paginationSubject.next(filter);
  }
  /* Observable to track device filter changes */
  get pagination$(): Observable<any> {
    return this.paginationSubject.asObservable();
  }
  get ppeGateFilter(): any {
    return this.ppeGateFilterSubject.getValue();
  }
  set ppeGateFilter(filter: any) {
    this.ppeGateFilterSubject.next(filter);
  }
  /* Observable to track device filter changes */
  get ppeGateFilter$(): Observable<any> {
    return this.ppeGateFilterSubject.asObservable();
  }
  get hourFilterEnabled(): boolean {
    return this.hourFilterEnabledSubject.getValue();
  }
  set hourFilterEnabled(enabled: boolean) {
    this.hourFilterEnabledSubject.next(enabled);
  }
  get hourFilterEnabled$(): Observable<boolean>{
    return this.hourFilterEnabledSubject.asObservable();
  }
  get monthFilterEnabled(): boolean {
    return this.monthFilterEnabledSubject.getValue();
  }
 
  set monthFilterEnabled(enabled: boolean) {
    this.monthFilterEnabledSubject.next(enabled);
  }

  get monthFilterEnabled$(): Observable<boolean> {
    return this.monthFilterEnabledSubject.asObservable();
  }
  get trend(): any {
    return this.trendSubject.getValue();
  }
  set trend(filter: any) {
    this.trendSubject.next(filter);
  }
  /* Observable to track device filter changes */
  get trend$(): Observable<any> {
    return this.trendSubject.asObservable();
  }
  get trendforklift(): any {
    return this.trendforkliftSubject.getValue();
  }
  set trendforklift(filter: any) {
    this.trendforkliftSubject.next(filter);
  }
  /* Observable to track device filter changes */
  get trendforklift$(): Observable<any> {
    return this.trendforkliftSubject.asObservable();
  }
  get areaGraph(): any {
    return this.areaGraphSubject.getValue();
  }
  set areaGraph(filter: any) {
    this.areaGraphSubject.next(filter);
  }
  /* Observable to track device filter changes */
  get forkliftGraph$(): Observable<any> {
    return this.forkliftGraphSubject.asObservable();
  }
  get forkliftGraph(): any {
    return this.forkliftGraphSubject.getValue();
  }
  set forkliftGraph(filter: any) {
    this.forkliftGraphSubject.next(filter);
  }
  /* Observable to track device filter changes */
  get areaGraph$(): Observable<any> {
    return this.areaGraphSubject.asObservable();
  }
  get ppeVehicleFilter(): any {
    return this.ppeVehicleFilterSubject.getValue();
  }
  set ppeVehicleFilter(filter: any) {
    this.ppeVehicleFilterSubject.next(filter);
  }
  /* Observable to track device filter changes */
  get ppeVehicleFilter$(): Observable<any> {
    return this.ppeVehicleFilterSubject.asObservable();
  }
 
  /* Getter and Setter for device filter */
  get cameraFilter(): any {
    return this.cameraFilterSubject.getValue();
  }
  set cameraFilter(filter: any) {
    this.cameraFilterSubject.next(filter);
  }
  /* Observable to track device filter changes */
  get cameraFilter$(): Observable<any> {
    return this.cameraFilterSubject.asObservable();
  }
  get cameraGFilter(): any {
    return this.cameraGFilterSubject.getValue();
  }
  set cameraGFilter(filter: any) {
    this.cameraGFilterSubject.next(filter);
  }
  /* Observable to track device filter changes */
  get sidenav$(): Observable<any> {
    return this.sidenavSubject.asObservable();
  }
  get sidenav(): any {
    return this.sidenavSubject.getValue();
  }
  set sidenav(filter: any) {
    this.sidenavSubject.next(filter);
  }
  /* Observable to track device filter changes */
  get cameraGFilter$(): Observable<any> {
    return this.cameraGFilterSubject.asObservable();
  }
  private currentViewSubject = new BehaviorSubject<string>('tile');
  currentView$ = this.currentViewSubject.asObservable();
 
  toggleView(): void {
    const newView = this.currentViewSubject.value === 'tile' ? 'table' : 'tile';
    this.currentViewSubject.next(newView);
  }
  private mySubject = new BehaviorSubject<any>(null);
 
  getMySubject() {
    return this.mySubject.asObservable();
  }
 
  doSomething(text: string) {
    this.mySubject.next(text);
  }
  getNotificationSubject() {
    return this.notificationSubject.asObservable();
  }
  notifyTicketStatus() {
    this.updateNotification({ ticketStatus: true });
  }
    notifyProbability() {
    this.updateNotification({ probability: true });
  }
  notifyUserAdded() {
    this.updateNotification({ userAdded: true });
  }
  notifyUserEdited() {
    this.updateNotification({ userEdited: true });
  }
  notifyUserDeleted() {
    this.updateNotification({ userDeleted: true });
  }
  notifyZoneAdded() {
    this.updateNotification({ zoneAdded: true });
  }
  notifyZoneEdited() {
    this.updateNotification({ zoneEdited: true });
  }
  notifyZoneDeleted() {
    this.updateNotification({ zoneDeleted: true });
  }
  notifyOperatorAdded() {
    this.updateNotification({ operatorAdded: true });
  }
  notifyOperatorEdited() {
    this.updateNotification({ operatorEdited: true });
  }
  notifyOperatorDeleted() {
    this.updateNotification({ operatorDeleted: true });
  }
  notifyDeviceEdited() {
    this.updateNotification({ deviceEdited: true });
  }
  notifyDeviceDeleted() {
    this.updateNotification({ deviceDeleted: true });
  }
  notifyVehicleAddes() {
    this.updateNotification({ vehicleAdded: true });
  }
  notifyVehicleEdited() {
    this.updateNotification({ vehicleEdited: true });
  }
  notifyVehicleDeleted() {
    this.updateNotification({ vehicleDeleted: true });
  }
  private updateNotification(update: Partial<NotificationType>) {
    const currentNotifications = this.notificationSubject.value;
    this.notificationSubject.next({ ...currentNotifications, ...update });
  }
  get token(): any {
    return this.tokenSubject.getValue();
  }
  set token(filter: any) {
    this.tokenSubject.next(filter);
  }
  /* Observable to track device filter changes */
  get token$(): Observable<any> {
    return this.tokenSubject.asObservable();
  }
  private filteredZoneBoundariesSubject = new BehaviorSubject<any[]>([]);

  get filteredZoneBoundaries$(): Observable<any[]> {
    return this.filteredZoneBoundariesSubject.asObservable();
  }

  get filteredZoneBoundaries(): any[] {
    return this.filteredZoneBoundariesSubject.getValue();
  }

  set filteredZoneBoundaries(value: any[]) {
    this.filteredZoneBoundariesSubject.next(value);
  }
}